// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"f1b6b70e","55":"ec55fc4a","79":"5476d654","194":"1529e8c6","395":"1d23c198","499":"b5bce521"}[chunkId] + ".css";
};